import React from "react";
import AdminHomePage from "./AdminHomePage";

const AdminDashboardPage: React.FC = () => {
  return <AdminHomePage />;
};

export default AdminDashboardPage;
